/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { ScenarioAnalysis } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function ScenarioAnalysisUpdateForm(props) {
  const {
    id: idProp,
    scenarioAnalysis: scenarioAnalysisModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    DataSetName: "",
    Description: "",
    WhyNoScenario: "",
  };
  const [DataSetName, setDataSetName] = React.useState(
    initialValues.DataSetName
  );
  const [Description, setDescription] = React.useState(
    initialValues.Description
  );
  const [WhyNoScenario, setWhyNoScenario] = React.useState(
    initialValues.WhyNoScenario
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = scenarioAnalysisRecord
      ? { ...initialValues, ...scenarioAnalysisRecord }
      : initialValues;
    setDataSetName(cleanValues.DataSetName);
    setDescription(cleanValues.Description);
    setWhyNoScenario(cleanValues.WhyNoScenario);
    setErrors({});
  };
  const [scenarioAnalysisRecord, setScenarioAnalysisRecord] = React.useState(
    scenarioAnalysisModelProp
  );
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(ScenarioAnalysis, idProp)
        : scenarioAnalysisModelProp;
      setScenarioAnalysisRecord(record);
    };
    queryData();
  }, [idProp, scenarioAnalysisModelProp]);
  React.useEffect(resetStateValues, [scenarioAnalysisRecord]);
  const validations = {
    DataSetName: [{ type: "Required" }],
    Description: [],
    WhyNoScenario: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          DataSetName,
          Description,
          WhyNoScenario,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            ScenarioAnalysis.copyOf(scenarioAnalysisRecord, (updated) => {
              Object.assign(updated, modelFields);
            })
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "ScenarioAnalysisUpdateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Climate Related Scenario Analysis"
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Heading>
      <Heading
        children="NZCS1 paragraph 11b."
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Heading>
      <Text
        children="Update this record that collates data about the scenario analyses you have used to identify climate-related risks and opportunities and better understand the resilience of your business model and strategy.  This must include a description of how you analysed, at a minimum, a 1.5 degrees Celsius climate-related scenario, a 3 degrees Celsius or greater climate-related scenario, and a third climate-related scenario."
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextField
        label="Scenario analysis record name (e.g. 2025 climate-related scenario analysis records)"
        isRequired={true}
        isReadOnly={false}
        value={DataSetName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName: value,
              Description,
              WhyNoScenario,
            };
            const result = onChange(modelFields);
            value = result?.DataSetName ?? value;
          }
          if (errors.DataSetName?.hasError) {
            runValidationTasks("DataSetName", value);
          }
          setDataSetName(value);
        }}
        onBlur={() => runValidationTasks("DataSetName", DataSetName)}
        errorMessage={errors.DataSetName?.errorMessage}
        hasError={errors.DataSetName?.hasError}
        {...getOverrideProps(overrides, "DataSetName")}
      ></TextField>
      <TextAreaField
        label="Description (e.g. Climate-related scenario analysis records for 2025)"
        isRequired={false}
        isReadOnly={false}
        value={Description}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName,
              Description: value,
              WhyNoScenario,
            };
            const result = onChange(modelFields);
            value = result?.Description ?? value;
          }
          if (errors.Description?.hasError) {
            runValidationTasks("Description", value);
          }
          setDescription(value);
        }}
        onBlur={() => runValidationTasks("Description", Description)}
        errorMessage={errors.Description?.errorMessage}
        hasError={errors.Description?.hasError}
        {...getOverrideProps(overrides, "Description")}
      ></TextAreaField>
      <TextAreaField
        label="Optional: primary reason why not using climate-related scenario analysis to inform strategy"
        isRequired={false}
        isReadOnly={false}
        value={WhyNoScenario}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName,
              Description,
              WhyNoScenario: value,
            };
            const result = onChange(modelFields);
            value = result?.WhyNoScenario ?? value;
          }
          if (errors.WhyNoScenario?.hasError) {
            runValidationTasks("WhyNoScenario", value);
          }
          setWhyNoScenario(value);
        }}
        onBlur={() => runValidationTasks("WhyNoScenario", WhyNoScenario)}
        errorMessage={errors.WhyNoScenario?.errorMessage}
        hasError={errors.WhyNoScenario?.hasError}
        {...getOverrideProps(overrides, "WhyNoScenario")}
      ></TextAreaField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || scenarioAnalysisModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || scenarioAnalysisModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
